module.exports = __webpack_public_path__ + "img/edc-ocbc.bdba7586.png";